import React from 'react'
import { RoundedContainer } from '../MyPracticeStyles'
import LoggedIcon from 'components_v2/Icons/LoggedIcon'
import { ElapsedTimeSince } from '../ElapsedTimeSince'

const mapCoaches = (coaches) => {
  return coaches.map((coach) => `${coach.firstName} ${coach.lastName}`)
}

const getCompletedIcon = (completed) => (
  <RoundedContainer
    width={['19px', '25px']}
    height={['18px', '25px']}
    backgroundColor={!completed ? '#bbbbbb' : '#000'}
    padding='0'
  >
    <LoggedIcon width='21px' height='20px' />
  </RoundedContainer>
)

export const mapDataClasses = (data) => {
  return data.classes.map((item) => ({
    ...item,
    completedIcon: getCompletedIcon(item.completed),
    image: item.videoThumbnail ? item.videoThumbnail : item.plan.thumbnailImage,
    title: item.title,
    classUrl: item.planEntryUrl,
    seriesUrl: item.planUrl,
    seriesName: item.plan.title,
    coaches: mapCoaches(item.plan.coaches).join(', '),
    plan: {
      coaches:
        item.plan?.coaches?.map((coach) => ({
          firstName: coach.firstName,
          lastName: coach.lastName
        })) || [],
      primaryCategory: { title: item?.category?.title },
      subcategory: { title: item?.subcategory?.title },
      difficultyLevel: item?.classDifficulty,
      title: item.plan.title,
      slug: item.plan.slug,
      singleClass: item.plan?.singleClass
    },
    duration: item?.humanDuration,
    dateCompleted: ElapsedTimeSince(item.favorites[0]?.createdAt),
    id: item?.id,
    completedAt: item?.completedAt
  }))
}
